import Client from "./Clients/AxiosClient";
const base = "/api/v1/admin/products";
const detail = "/api/v1/admin/product-details";
const type = "/api/v1/product_type";

export default {
  get(payload) {
    return Client.get(base, {
      params: {
        page: payload.page || 1,
        page_size: payload.page_size || 10,
        type: payload.type || "",
        search: payload.search || "",
      },
    });
  },
  create(payload) {
    return Client.post(`${base}`, payload);
  },
  getDetail(id) {
    return Client.get(`${base}/${id}`);
  },
  update(id, payload) {
    return Client.put(`${base}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${base}/${id}`);
  },
  createDetail(id, payload) {
    return Client.post(`${detail}/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  getDetailsDetail(id, detail_id) {
    return Client.get(`${detail}/${id}/${detail_id}`);
  },
  updateDetail(id, payload) {
    return Client.put(`${detail}/update/${id}`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  deleteDetail(id) {
    return Client.delete(`${detail}/${id}`);
  },
  setType(payload) {
    return Client.post(`${type}`, payload);
  },
};
